module.exports = __webpack_public_path__ + "media/images/guidelines/video_share-c65f1038f20d92cf3924b32b985bb644.png";